import useStyleOptions from '/druid/useStyleOptions';

export default function useAvatarForBot(): [{ image: string; initials: string }] {
  const [{ botAvatarImage: image, botAvatarInitials: initials }] = useStyleOptions();

  return [
    {
      image,
      initials
    }
  ];
}
